import React, { FunctionComponent, useState } from 'react';
import { SectionHeader } from '@havenengineering/module-shared-owners-ui/dist/components/SectionHeader/SectionHeader';
import clsx from 'clsx';

import { accordionClick } from '../../helpers/googleTag';
import styles from './Terms.module.scss';

const Terms: FunctionComponent = () => {
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    accordionClick('terms and conditions', !expanded);
    setExpanded(!expanded);
  };

  return (
    <div className={styles.root}>
      <div className={styles.title} onClick={handleExpandClick}>
        <SectionHeader
          title="Terms &amp; conditions"
          extraContent={
            <img
              className={clsx(styles.expand, {
                [styles.expandOpen]: expanded,
              })}
              src="https://www.haven.com/assets/icons/arrow-ios-up-blue.svg"
              alt="arrow"
            />
          }
        />
      </div>
      {expanded && (
        <div className={styles.content}>
          <div className="owners-body">
            <h3>Drain Down &amp; Reconnection - Terms &amp; conditions</h3>
            <ol>
              <li>
                If there is a frost before your booked drain down date, we may
                not be able to carry out your drain down. In this instance we
                will not charge you and you will be notified.
              </li>
              <li>
                If we carry out your drain down during a frost then the Haven
                &lsquo;Frost-Free Guarantee&rsquo; will not apply as we cannot
                verify all your pipework, appliances and boiler were operational
                before we started, we will notify you if this is the case.
              </li>
              <li>
                Reconnection will happen in the week you request unless there is
                a high risk of frost damage, in which case we will ask you if
                you want to proceed or wait.
              </li>
              <li>
                Once the reconnection has taken place, we will check for leaks
                and damage, the water will be turned off at the stopcock, and
                your holiday home signed off as frost damage-free.
              </li>
              <li>
                Please note frosts can still occur after 1 March so we advise
                you request your reconnection for when you are sure you will be
                occupying your holiday home.
              </li>
              <li>
                Please be advised that due to the volume of drain downs we may
                need to ask qualified external contractors to assist us.
              </li>
              <li>
                Please do not assume that we will have a set of keys. If you
                have E, M, Union, or A-type keys and no auxiliary locks you will
                not need to leave a set of keys. If you are in doubt, please
                call us.
              </li>
              <li>
                Please note, do not attempt to use any water or gas appliances
                after your drain down has been carried out.
              </li>
              <li>
                Inhibitor replacement or top-up to -15deg (30% concentration)
                will be done in a product such as &lsquo;Fernox Alphi 11&rsquo;
                or &lsquo;Sentinel 500&rsquo; which are recommended by boiler
                manufacturers.
              </li>
              <li>
                A free inhibitor &ldquo;top-up&rdquo; is included in the price
                of the drain down. A free top-up is when your reading is between
                -14deg and -10deg, we will top-up your inhibitor up to -15deg
                free of charge.
              </li>
              <li>
                A chargeable inhibitor &ldquo;top-up&rdquo; is when your reading
                is between -9deg and -6deg. Your inhibitor will be topped up to
                -15deg at the current cost per litre.
              </li>
              <li>
                If a full caravan inhibitor replacement (approx. 6 litres for
                caravans and 15 litres for twin units) is required, this will be
                charged at the current rate per litre. It is usually more
                economical to replace the entire inhibitor if your readings are
                higher than -5deg.
              </li>
              <li>
                For any additional winterisation services, we may carry these
                out at the start of next season rather than during the winter
                closed period. In the case of wet carpet and upholstery cleans
                this stops your caravan staying damp over the winter, for other
                services such as cleaning this gives you the freshest clean for
                when you are actually using your caravan.
              </li>
            </ol>
            <h3>Haven Frost Free Guarantee:</h3>
            <ol>
              <li>
                Haven will guarantee any pipework, plumbing fixings,
                sanitaryware, dishwashers and washing machines, boilers and
                heating after a Haven a drain down and before Haven
                reconnection. These items will be repaired free of charge if
                they have frost damage. This is provided any subsequent fault is
                limited and exclusively linked to frost damage from expanding
                water and not a general fault with the appliance.
              </li>
              <li>
                Haven will check your caravan for any leaks and the operation of
                your hot water and heating (if applicable) prior to draining it
                down. Haven will also make the same checks when the caravan is
                reconnected. If there is any frost damage in relation to the
                items in section 1 above when the caravan is reconnected by
                Haven, we will rectify this free of charge.&nbsp;
              </li>
              <li>
                The stop cock on your holiday home must remain turned off after
                the Haven Drain Down has been completed until the Haven
                reconnection is completed to qualify for the Haven Frost Free
                Guarantee.
              </li>
              <li>
                The Frost-Free Guarantee will end at the point when your caravan
                is reconnected to water and re-tested and signed off as free
                from frost damage, at this point the stopcock will be left in
                the &lsquo;off&rsquo; position. Any frost damage after this
                point is the responsibility of the owner.
              </li>
              <li>
                There could be a delay for repair work if a large volume of
                holiday homes have frost damage. We will prioritise any
                winterisation repair work to those owners that have undertaken
                their drain down with us.
              </li>
            </ol>
            <p>
              The Haven Frost Free Guarantee is a service provided by Haven and
              not a guarantee that your insurance policy will respond.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Terms;
